import React from "react";
import "./TermsConditions.css";

const TermsConditions = () => {
    return (
        <div className="terms-page">
            <div className="terms-container">
                <h1 className="terms-title">Terms & Conditions</h1>
                <section className="terms-section">
                    <h2>Introduction</h2>
                    <p>
                        Welcome to MAS Mobility Service. These Terms & Conditions ("Agreement") govern your access to and use of our website and services. Please read this Agreement carefully before using this website. By accessing, browsing, or using this website, you acknowledge that you have read, understood, and agreed to be bound by these Terms & Conditions.

                        Any modifications to this Agreement will become effective immediately upon posting on this website. We encourage you to review this page periodically for updates. Your continued use of the website after any changes are posted constitutes your acceptance of those changes.
                    </p>
                    <p>
                        Throughout this Agreement, the terms "we," "us," "our," and "MAS Mobility Service" refer to MAS Mobility Service, headquartered in Jeddah, Kingdom of Saudi Arabia. MAS Mobility Service provides transportation, mobility, vehicle rental, corporate transportation, chauffeur services, logistics support, and related mobility solutions to individuals, businesses, and organizations.

                        By using our website, you agree to comply with all applicable laws, regulations, and these Terms & Conditions. If you do not agree with any part of this Agreement, you should discontinue use of this website immediately.
                    </p>
                </section>
                <section className="terms-section">
                    <h2>Copyright</h2>
                    <p>
                        All content on this website, including but not limited to text, graphics, logos, images, software, designs, videos, icons, and other materials ("Site Materials"), is the property of MAS Mobility Service or its licensors and is protected by applicable copyright laws and international intellectual property regulations.

                        Unauthorized copying, reproduction, distribution, modification, publication, transmission, or commercial exploitation of any Site Materials without prior written consent from MAS Mobility Service is strictly prohibited.
                    </p>
                </section>
                <section className="terms-section">
                    <h2>Trademarks</h2>
                    <p>
                        MAS Mobility Service, its logo, service names, brand elements, and related marks displayed on this website are the exclusive property of MAS Mobility Service and are protected under applicable trademark laws.

                        Any unauthorized use of our trademarks, trade names, logos, or branding materials is strictly prohibited. All third-party trademarks appearing on this website remain the property of their respective owners.
                    </p>
                </section>
                <section className="terms-section">
                    <h2>Privacy</h2>
                    <p>
                        Any personal information collected through this website is handled in accordance with our Privacy Policy. By using this website, you consent to the collection, use, storage, and processing of your information as described in our Privacy Policy.
                    </p>
                </section>
                <section className="terms-section">
                    <h2>Registration</h2>
                    <p>
                        Certain areas of the website may require registration or account creation. You agree to provide accurate, current, and complete information during registration and to maintain the accuracy of such information.

                        You are responsible for safeguarding your account credentials and for all activities conducted under your account.
                    </p>
                </section>
                <section className="terms-section">
                    <h2>Governing Law</h2>
                    <p>
                        These Terms & Conditions shall be governed by and interpreted in accordance with the laws of the Kingdom of Saudi Arabia. Any disputes arising from the use of this website shall be subject to the exclusive jurisdiction of the courts of Jeddah, Saudi Arabia.
                    </p>
                </section>
                <section className="terms-section">
                    <h2>Code of Conduct</h2>
                    <p>
                        When using this website, you agree not to:
                        . Violate any applicable laws or regulations.
                        . Upload or transmit malicious software, viruses, or harmful code.
                        . Attempt unauthorized access to systems, accounts, or data.
                        . Interfere with website operations or security.
                        . Post unlawful, defamatory, abusive, fraudulent, or offensive content.
                        . Use automated tools to scrape, collect, or extract website data without authorization.
                    </p>
                </section>
                <section className="terms-section">
                    <h2>Services and Bookings</h2>
                    <p>
                        When requesting transportation, mobility, vehicle rental, or related services through this website, you agree to provide accurate information and comply with all applicable booking requirements.

                        MAS Mobility Service reserves the right to refuse, cancel, or modify bookings when necessary, including instances involving inaccurate information, payment issues, or service availability constraints.
                    </p>
                </section>
                <section className="terms-section">
                    <h2>Links to Third-Party Websites</h2>
                    <p>
                        This website may contain links to external websites. MAS Mobility Service is not responsible for the content, accuracy, privacy practices, or availability of third-party websites.
                    </p>
                </section>
                <section className="terms-section">
                    <h2>Limitation of Liability</h2>
                    <p>
                        To the maximum extent permitted by law, MAS Mobility Service shall not be liable for any direct, indirect, incidental, consequential, special, or punitive damages arising from your use of, or inability to use, this website or its services.
                    </p>
                </section>
                <section className="terms-section">
                    <h2>Accuracy of Information</h2>
                    <p>
                        While we strive to maintain accurate and up-to-date information, MAS Mobility Service does not guarantee the completeness, reliability, or accuracy of any content published on this website.
                    </p>
                </section>
                <section className="terms-section">
                    <h2>Disclaimer</h2>
                    <p>
                        This website and all content are provided on an "as is" and "as available" basis without warranties of any kind, whether express or implied.

                        MAS Mobility Service makes no guarantee that the website will be uninterrupted, error-free, secure, or free from harmful components.
                    </p>
                </section>
                <section className="terms-section">
                    <h2>Indemnification</h2>
                    <p>
                        You agree to indemnify, defend, and hold harmless MAS Mobility Service, its employees, directors, officers, affiliates, and partners from any claims, damages, liabilities, losses, costs, or expenses arising from your violation of these Terms & Conditions or misuse of the website.
                    </p>
                </section>
                <section className="terms-section">
                    <h2>Availability of Website</h2>
                    <p>
                        We reserve the right to modify, suspend, restrict, or discontinue any part of this website at any time without prior notice.
                    </p>
                </section>
                <section className="terms-section">
                    <h2>Use of Cookies</h2>
                    <p>
                        We may use cookies and similar technologies to improve user experience, analyze website traffic, and enhance our services. Continued use of the website constitutes consent to such usage.
                    </p>
                </section>
                <section className="terms-section">
                    <h2>Contact Us</h2>
                    <p>
                        MAS Mobility Service
                        Jeddah, Kingdom of Saudi Arabia

                        For questions regarding these Terms & Conditions, please contact us through our Contact Us page.
                    </p>
                </section>
            </div>
        </div>
    );
};

export default TermsConditions;